import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from "reactstrap";

import relativeDayjs, { CALENDAR_SETTINGS } from "./helpers/relativeDayjs";

const CommentTimestamp = ({ className, timestamp, tooltip }) => {
  const timestampRef = useRef(null);
  return (
    <React.Fragment>
      <div ref={timestampRef} id="timestamp" className={className}>
        {relativeDayjs(timestamp).fromNow()}
      </div>
      {tooltip &&
        <UncontrolledTooltip placement="right" target={timestampRef}>
          {relativeDayjs(timestamp).calendar(...CALENDAR_SETTINGS)}
        </UncontrolledTooltip>
      }
    </React.Fragment>
  );
};

CommentTimestamp.defaultProps = {
  tooltip: false
};

CommentTimestamp.propTypes = {
  className: PropTypes.string,
  timestamp: (props, propName, componentName) => {
    if (!props[propName] || isNaN(Date.parse(props[propName]))) {
      return new Error(`Invalid prop ${propName} supplied to ${componentName}. Must be a valid Date.`);
    }
  },
  tooltip: PropTypes.bool
};

export default CommentTimestamp;
